import lottie from "lottie-web"
import emailAnimation from "../../animations/email.json"
import thankYouAnimation from "../../animations/thank-you.json"
import giftAnimation from "../../animations/gift.json"
import giftAnimationV2 from "../../animations/gift-v2.json"
import giftAnimationEI from "../../animations/gift-ei.json"
import arrowAnimation from "../../animations/animated-arrow.json"
import discountScratchCardAnimation from "../../animations/discount-scratch-card.json"
import discountScratchCardAnimationV2 from "../../animations/discount-scratch-card-v2.json"

const animationsLoaders = {
  discountScratchCardAnimation: (id) => {
    lottie.loadAnimation({
      container: document.querySelector(`#${id}`),
      animationData: discountScratchCardAnimation,
      renderer: "svg",
      loop: true,
      autoplay: true,
    })
  },
  discountScratchCardAnimationV2: (id) => {
    lottie.loadAnimation({
      container: document.querySelector(`#${id}`),
      animationData: discountScratchCardAnimationV2,
      renderer: "svg",
      loop: true,
      autoplay: true,
    })
  },
  emailAnimation: (id) => {
    const animation = lottie.loadAnimation({
      container: document.querySelector(`#${id}`),
      animationData: emailAnimation,
      renderer: "svg",
      loop: true,
      autoplay: true,
    })

    animation.setSpeed(0.8)

    // To avoid jittery animation, make a small delay before
    // the playback to wait until the view is fully rendered.
    setTimeout(() => {
      requestAnimationFrame(() => animation.play())
    }, 800)
  },
  thankYouAnimation: (id) => {
    lottie.loadAnimation({
      container: document.querySelector(`#${id}`),
      animationData: thankYouAnimation,
      renderer: "svg",
      loop: true,
      autoplay: true,
    })
  },
  giftAnimation: (id) => {
    lottie.loadAnimation({
      container: document.querySelector(`#${id}`),
      animationData: giftAnimation,
      renderer: "svg",
      loop: true,
      autoplay: true,
    })
  },
  giftAnimationV2: (id) => {
    lottie.loadAnimation({
      container: document.querySelector(`#${id}`),
      animationData: giftAnimationV2,
      renderer: "svg",
      loop: true,
      autoplay: true,
    })
  },
  giftAnimationEI: (id) => {
    lottie.loadAnimation({
      container: document.querySelector(`#${id}`),
      animationData: giftAnimationEI,
      renderer: "svg",
      loop: true,
      autoplay: true,
    })
  },
  arrowAnimationLeft: (id) => {
    lottie.loadAnimation({
      container: document.querySelector(`#${id}`),
      animationData: arrowAnimation,
      renderer: "svg",
      loop: true,
      autoplay: true,
    })
  },
  arrowAnimationRight: (id) => {
    lottie.loadAnimation({
      container: document.querySelector(`#${id}`),
      animationData: arrowAnimation,
      renderer: "svg",
      loop: true,
      autoplay: true,
    })
  },
}

export default animationsLoaders;
